var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"page-header",attrs:{"no-gutters":""}},[_c('b-col',{domProps:{"innerHTML":_vm._s(_vm.pageTitle)}})],1),_vm._v(" "),_c('div',{staticClass:"arrow-down"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }